import LZString from 'lz-string';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { Bar } from 'react-chartjs-2';
import SensorInfo from '../../components/modals/SensorInfo';
import logo from './../../assets/img/favicon-dark.png';
import DateUtil from '../../util/DateUtil';
import CommonUtils from '../../util/CommonUtils';
import SessionManager from '../../routes/SessionManager';
import API from '../../service/SiteKickAPIService';

let timezone;
function StandardDailyReport() {

  const [user, setUser] = useState(null);
  const [person_info, setPersonInfo] = useState({});
  const [sensor_info, setSensorInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState({});
  const [chart_data, setChartData] = useState(null);

  const getPathParams = () => {
    var pathParams = window.location.search;
    pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
    return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
  }

  useEffect(() => {
    document.body.style.backgroundColor = '#fff';
    var userObj = getPathParams();
    timezone = userObj.site_selected.site_iana_timezone;
    let zones = {};

    for (let z of userObj.zones) {
      zones[z.location_id] = z;
    }

    let sessionManager = new SessionManager();
    sessionManager.storeCookie('user', userObj);
    setUser(userObj);
    setZones(zones)

    if (!timezone)
      timezone = moment.tz.guess();

    setLoading(true);
  }, [])

  useEffect(() => {
    if (user !== null && user.site_selected) {
      fetchStandardDailyReport();
    }
  }, [user]);

  const fetchStandardDailyReport = () => {
    var payload = {
      customer_id: user.customer_id,
      site_id: user.site_selected.site_id,
      user_login: user.user_login,
      user_token: user.user_token,
      date: user.date,
      timezone: timezone
    }

    let { work_hours_start, work_hours_end } = user.site_selected && user.site_selected.site_config ? user.site_selected.site_config.work_hours : { work_hours_start: '07:00', work_hours_end: '17:00' };
    payload = { ...payload, work_hours_start, work_hours_end: work_hours_end.replace(":00", ":59") }
    CommonUtils.ajax(
      {
        url: API.REPORTS.STANDARD_DAILY,
        type: 'POST',
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(payload)
      }
    ).then(
      (res) => {
        if (res.status && res.status.code === 200) {
          var data = res.data;
          setLoading(false);
          data.sensor_infos = {};

          for (let z1 in data.sensor_info) {
            data.sensor_infos[z1] = [];
            //console.log(zones[z1].location_name);

            var sensorInfoRecs = data.sensor_info[z1];
            var sensorData = [];
            var personsMap = {};
            var images = [null, null, null];
            let persons = [null, null, null];

            var p1 = data.person_info[z1];
            var personTimeStamps = [p1.start_person_ts, p1.max_person_ts, p1.last_person_ts];

            personsMap[p1.start_person_ts] = p1.start_person_count;
            personsMap[p1.max_person_ts] = p1.max_person_count;
            personsMap[p1.last_person_ts] = p1.last_person_count;

            for (let sensorInfoRec of sensorInfoRecs) {
              var sensor_recs = JSON.parse(sensorInfoRec.sensor_info);
              let y = sensorInfoRec.dev_timestamp;
              let yStr = moment.tz(sensorInfoRec.dev_timestamp * 1000, timezone).format('MMM DD, YYYY HH:mm');

              for (let sensor_rec of sensor_recs) {
                sensor_rec.dev_timestamp = yStr;
                sensor_rec.howMany = personTimeStamps.filter(function (x) { return x === y; }).length;
                sensor_rec.pos = personTimeStamps.lastIndexOf(y);

                for (let i = 2; i >= 0; i--) {
                  var hr = moment.tz(sensorInfoRec.dev_timestamp * 1000, timezone).format('h a').toUpperCase();
                  hr = hr.length === 4 ? '0' + hr : hr;
                  if (images[i] && (i < sensor_rec.pos)) {
                    break;
                  } else {
                    images[i] = sensorInfoRec.image;
                    persons[i] = { dev_timestamp: hr, person_count: personsMap[y] };
                  }
                }

              }

              sensorData = sensorData.concat(sensor_recs);
            }

            // console.log('SensorData ' + JSON.stringify(sensorData));
            // console.log('personTimeStamps ' + personTimeStamps);

            if (sensorData.length > 0) {

              var sensorCombi = {};
              var sensorInfo = {};

              data.sensor_infos[z1].push({ images: images, persons: persons, sensorInfo: sensorInfo });
              var sensorCount = 0;
              for (let s of sensorData) {
                //var howMany = s.howMany;
                let combi = (s.device_id + '-' + s.name);
                let d = sensorCombi[combi];
                if (!d) {
                  d = sensorCombi[combi] = (s.device_id === s.name) ? 'Gateway' : 'Sensor ' + (++sensorCount) + ': ' + s.name;
                }

                if (!sensorInfo[d])
                  sensorInfo[d] = {};

                if (!sensorInfo[d][s.sensor_id]) {
                  sensorInfo[d][s.sensor_id] = [null, null, null];
                }

                //var finalTS = moment.tz(personTimeStamps[2] * 1000, timezone).format('MMM DD, YYYY HH:mm');

                // We can build using one parm which comes 3 times. once done, take array out.
                if (!sensorInfo[d][d])
                  sensorInfo[d][d] = [null, null, null];


                var pos = s.pos;
                for (let i = 2; i >= 0; i--) {
                  if (sensorInfo[d][d][i] && (i < pos)) {
                    break;
                  } else {
                    sensorInfo[d][d][i] = s.dev_timestamp;
                  }
                }

                for (let i = 2; i >= 0; i--) {
                  if (sensorInfo[d][s.sensor_id][i] && (i < pos)) {
                    break;
                  } else {
                    sensorInfo[d][s.sensor_id][i] = s;
                  }
                }

              }

            }
          }
          //console.log(JSON.stringify(data.sensor_infos, null, 4))
          // Chart Data Preparation.
          var chartData = {};

          var hrs = DateUtil.getWorkHours(user.site_selected.site_config.work_hours, "hh A");
          for (let z in zones) {
            let persons = [];
            for (var i in hrs) {
              persons[i] = 0;
            }
            var zoneChartData = data.person_info_full[z];
            if (zoneChartData) {
              for (let rec of zoneChartData) {
                let hr = moment.tz(rec.dev_timestamp * 1000, timezone).format('h a').toUpperCase();
                hr = hr.length === 4 ? '0' + hr : hr;

                var idx = hrs.indexOf(hr);
                if (idx !== -1) {
                  if (persons[idx] < rec.person_count) {
                    persons[idx] = rec.person_count;
                  }
                }
              }
            }

            const array = persons;
            chartData[z] = {
              labels: hrs,
              personsFound: false,
              datasets: [
                {
                  label: 'People',
                  backgroundColor: 'rgba(0,123,255,0.8)',
                  borderWidth: 0,
                  hoverBackgroundColor: 'rgba(0,123,255,0.9)',
                  data: persons,
                }
              ]
            }
            if (Math.max(...array) > 0) {
              chartData[z].personsFound = true;
            } else {
              chartData[z].personsFound = false;
            }
          }
          setPersonInfo(data.person_info);
          setSensorInfo(data.sensor_infos);
          setChartData(chartData);
        }

      },
      (res) => {

      });
  }

  let setPDFContentReady = () => {
    window.status = "ready";
  };

  const chart = {
    data: {
      labels: [],
      datasets: [
        {
          label: 'People',
          backgroundColor: 'rgba(0,123,255,0.8)',
          borderWidth: 0,
          hoverBackgroundColor: 'rgba(0,123,255,0.9)',
          data: [],
        }
      ]
    },
    options: {
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 30,
          bottom: 0
        }
      },
      legend: {
        display: false
      },
      responsive: true,
      scales: {
        xAxes: [{
          display: true,
          gridLines: {
            display: false
          },
          scaleLabel: {
            display: true,
            labelString: 'Hour',
            fontColor: 'orange'
          }
        }],
        yAxes: [
          {
            display: true,
            gridLines: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: 'Max. Person Count',
              fontColor: 'orange'
            },
            ticks: {
              min: 0, // it is for ignoring negative step.
              beginAtZero: true,
              callback: function (value, index, values) {
                if (Math.floor(value) === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      maintainAspectRatio: false
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12 my-5">
          <span className="navbar-brand text-primary">
            <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
            {"SiteSupt OnDemand"}
          </span>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <h4>Standard Daily Report</h4>
        </div>
        <div className="col-md-12">
          <h5 className="text-app">{user && user.site_selected.site_name}</h5>
        </div>
        <div className="col-md-12">

          {!loading &&

            <table className="table table-bordered mt-5">
              <thead>
                <tr>
                  <th className="p-0" colSpan="4"><div className="bg-primary p-2 text-white">Man Power Report (Daily)</div></th>
                </tr>
                <tr className="bg-light border-1">
                  <th className="p-1">Zone Name</th>
                  <th className="p-1">Max. Person Count</th>
                  <th className="p-1">First Appearance</th>
                  <th className="p-1">Last Appearance</th>
                </tr>
              </thead>
              <tbody>
                {
                  Object.keys(zones).map((w, i) => (
                    (zones[w].detect_motion) &&
                    <tr className="font-size-12" key={i}>
                      <td className="p-2">{zones[w].location_name}</td>
                      <td className="p-2">{person_info[w] ? person_info[w].max_person_count : 0}</td>
                      <td className="p-2">{person_info[w] ? moment.tz(person_info[w].start_person_ts * 1000, timezone).format('YYYY-MM-DD HH:mm') : 0}</td>
                      <td className="p-2">{person_info[w] ? moment.tz(person_info[w].last_person_ts * 1000, timezone).format('YYYY-MM-DD HH:mm') : 0}</td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          }
        </div>
      </div>
      {chart_data && Object.keys(zones).map((z, i) => (
        zones[z].detect_motion &&
        <React.Fragment key={i}>
          <div className="card bg-shadow mt-4 align-print-page">
            <div className="card-header bg-primary text-light p-2">{zones[z]['location_name']}</div>
            <div className="card-body text-center">
              {chart_data[z].personsFound === true ?
                <div style={{ height: '175px', width: '80%' }}>
                  <Bar
                    style={{ position: "relative" }}
                    data={chart_data && chart_data[z] ? chart_data[z] : []}
                    height={150}
                    options={chart.options}
                  />
                </div> : "No Person Detected During Work Hours"
              }
            </div>
            {sensor_info[z] && sensor_info[z].length > 0 && sensor_info[z][0].sensorInfo && (
              <SensorInfo zoneInfo={zones[z]} zone={zones[z]['location_name']} data={sensor_info[z][0]} images={sensor_info[z][0].images} key={i} sensorInfo={sensor_info[z][0].sensorInfo} timezone={timezone}></SensorInfo>
            )
            }
          </div>
        </React.Fragment>
      ))
      }
      {setPDFContentReady()}

      <div className="row">
        <div className="col-md-12">
          <div className="text-small">
            <b>Disclaimer</b>: The Standard Daily Report contains information from the gateway devices and may include remote sensors which must be active and connected in order to report the data.
          </div>
        </div>
      </div>
    </div>
  )
}
export default StandardDailyReport;